import { useParams } from '@tanstack/react-router';
import { useParamsSearch } from '@anytag/shared-hooks';
import { TiktokTagsAnalyticsSearchSchemaType } from '../schemaTypes';

export const useTiktokTagsAnalyticsFilter = () => {
  const params = useParams({ strict: false });
  const paramsSearch = useParamsSearch<TiktokTagsAnalyticsSearchSchemaType>();

  return { ...paramsSearch, countryId: (params.countryId || 'jp').toUpperCase() };
};
